export const TOGGLE_MODAL = 'toggle_modal';
